import PageContext from "global_state/context/PageContext"
import { useContext, useEffect, useState } from "react"
import { GetEshopProductsService, GetSpecialOfferProductsServece } from "services/EshopServices"
import { ResponseError } from "types/responses/ResponseError"
import Loader from "../Loader"
import Title from "../Title"

import SCSS from 'assets/scss/Eshop.module.scss'
import Product from "./Product"
import content from 'languages/Eshop.json'
import AppSCSS from 'assets/scss/App.module.scss'


function Eshop() {

    const {page, dispatchPage} = useContext(PageContext)
    let language = page.settings.language

    const [eshop_response, setEshopResponse] = useState<string | any[]>()
    const [special_offer_response, setSpecialOfferResponse] = useState<string | any[]>()
    useEffect(() => {
        const products = async() => {
            setEshopResponse(await GetEshopProductsService())
        }
        const special_offer = async() => {
            setSpecialOfferResponse(await GetSpecialOfferProductsServece())
        }

        special_offer()
        products()
        
    }, [])

    if (!(eshop_response)) {
        return <Loader/>
    }

    if (typeof eshop_response === 'string') {
        return <Loader error={ResponseError.general_error}/>
    }

    const renderProducts = eshop_response.map((product, index) => {
        return (
            <Product key={"p" + index} product={product} index={index}/>
        )
    })
    
    const isSpecialOfferAvailable = () => {
        if (!special_offer_response) {
            return false
        }
        if (typeof special_offer_response == 'string') {
            return false
        }
        if (special_offer_response.length == 0) {
            return false
        }
        let now = new Date().getTime()

        let some = special_offer_response.some(p => p.display_from <= now && p.display_to >= now)
        
        return some
    }
    const renderSpecialOffersSubtitle = () => {
        if (isSpecialOfferAvailable() == false) {
            return 
        }
        return (
            <div className={AppSCSS.sub_title}>
                <h4>{content[language].special_offer_title}</h4>
            </div>
        )
    }
    const renderSpecialOffers = () => {
        if (!special_offer_response || typeof special_offer_response == 'string') {
            return 
        }

        let now = new Date().getTime()

        let products =  special_offer_response.map((product, index) => {
            
            // if product is not yet for the display 
            if (now < product.display_from.getTime()){
                return 
            }
            // if product is already not for display 
            if (now > product.display_to.getTime()) {
                return 
            }

            return <Product special_offer={true} key={"sop" + index} product={product}/>
        })

        return (
            products
        )

        // return (
        //     <>

        //         {renderSpecialOffersSubtitle()}

        //         <div className={[SCSS.special_offer_products, SCSS.products].join(" ")}>
                
        //             {products}
        //         </div>
        //     </>
            
        // )
    }

    const renderRegularSubtitle = () => {        
        if (isSpecialOfferAvailable() == false) {
            return 
        }
        return (
            <div className={AppSCSS.sub_title}>
                <h4>{content[language].regular_products_title}</h4>
            </div>
        )
    }
    const renderRegularProducts = () => {
        return renderProducts
        // return (
        //     <>
        //         {renderRegularSubtitle()}

        //         <div className={[SCSS.products, SCSS.regular_products].join(" ")}>
        //             {renderProducts}
        //         </div>    
        //     </>
        // )
    }
    
    return(
        <div>
            <Title back_arrow={true} title={content[language].title}/>
            <div className={SCSS.warning}>
                {content[language].warning}
            </div>
            <div className={[SCSS.products, SCSS.regular_products].join(" ")}>
                {renderSpecialOffers()}
                {renderRegularProducts()}
            </div>
            
        </div>
    )
}



export default Eshop